import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import React from 'react';
import PropTypes from 'prop-types';
import { withDetailedIcon } from '../DetailedIcon';
export var PencilDollarSVG = function PencilDollarSVG(_ref) {
  var children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 44 44"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__secondary-color-fill",
    d: "M38,6H23V4a2,2,0,0,0-4,0V6.047C14.766,6.4,9,8.936,9,15c0,7.209,8.608,9.866,10.84,10,.948.15,5.16,1.629,5.16,4,0,2.824-4.95,3-5,3-2,0-12.991-.032-12.991-.032l-.018,6S15.644,37.993,19,38v2a2,2,0,0,0,4,0V37.636c3.845-.886,8-3.49,8-8.636,0-7.209-8.608-9.866-10.84-10-.948-.15-5.16-1.629-5.16-4,0-2.824,4.95-3,5-3H38a3,3,0,0,0,0-6ZM20.133,19c-.063,0-.145,0-.112,0S20.091,19,20.133,19Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "DetailedIcon__accent-color-fill",
    points: "6 31 11 36 5 37 4 36 6 31"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "DetailedIcon__accent-color-fill",
    x: "27.672",
    y: "6.964",
    width: "5.657",
    height: "7.071",
    transform: "translate(1.509 24.642) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__foreground-color-fill",
    d: "M36.634,9.561l-5.2-5.2A1.216,1.216,0,0,0,30.575,4a1.246,1.246,0,0,0-.875.364L4.225,29.84a.6.6,0,0,0-.073.121.811.811,0,0,0-.146.207,1.313,1.313,0,0,0-.085.231c-.012.048-.036.085-.048.133L3.01,36.6A1.241,1.241,0,0,0,4.225,38a.816.816,0,0,0,.17-.012l6.071-.862c.049-.012.085-.037.134-.049a1.2,1.2,0,0,0,.23-.085.787.787,0,0,0,.207-.146.4.4,0,0,0,.121-.072L31.437,16.5l5.2-5.2A1.217,1.217,0,0,0,36.634,9.561ZM9.713,34.746l-4.043.583.583-4.044L25.378,12.16l3.46,3.461ZM30.575,13.9,27.1,10.424l3.473-3.461,3.46,3.461Z"
  }));
};
PencilDollarSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
PencilDollarSVG.defaultProps = {
  children: /*#__PURE__*/React.createElement("title", null, "Pencil and Dollar")
};
export default withDetailedIcon(PencilDollarSVG);